module.exports = "/_next/static/images/15-1-961711a153d06e910e29ca9e056f5e0c.svg";